import { HStack, StackProps, Text, VStack } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { SectionTitle } from '../atoms/Title.tsx';
import { useTheme } from '../../contexts/ThemeProvider.tsx';

export function Labeled({
  label,
  helpText,
  footerText,
  showMore,
  children,
  labelSize = '18px',
  labelColor,
  paddingRightActive,
  ...props
}: {
  label: string;
  showMore?: () => void;
  labelSize?: string | number;
  helpText?: string;
  paddingRightActive?: string;
  footerText?: string;
  labelColor?: string;
} & PropsWithChildren &
  StackProps) {
  const { colors } = useTheme();

  return (
    <VStack width={'100%'} align={'flex-start'} {...props}>
      <HStack width={'100%'} justify={'space-between'}>
        <SectionTitle width={showMore ? '75%' : '100%'} color={labelColor} fontSize={labelSize}>
          {label}
        </SectionTitle>
        {showMore && (
          <Text paddingRight={'20px'} fontSize={14} color={colors.primaryColor} cursor={'pointer'} onClick={showMore}>
            Ver tudo
          </Text>
        )}
      </HStack>

      {helpText && (
        <Text paddingRight={paddingRightActive || 0} marginTop={'-5px'} fontSize={'14px'} color={'#a9a9a9'}>
          {helpText}
        </Text>
      )}
      {children}
      {footerText && (
        <Text marginTop={'-5px'} fontSize={10} color={'#a9a9a9'}>
          {footerText}
        </Text>
      )}
    </VStack>
  );
}
